import React, { useEffect, useState, useRef } from "react"
import axios from 'axios'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { sha256 } from 'js-sha256'
import Header from "./components/header"
import Loader from "react-loader-spinner"

export const Inventaire = () => {

  const hash = sha256(process.env.REACT_APP_HMSG)
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(false)
  const qrcodeRef = useRef()

  /* 821;550;099992002;0;0;144;195;1;1205;03/07/2021;V1 */

  const [base, setBase] = useState({
    exports: [],
    list: [],
  })

  const [infoOutStock, setInfoOutStock] = useState({
    idcarton: ""
  })

  useEffect(() => {
    if (typeof window !== "undefined" && (base.exports.length === 0 || reload)) {
      axios.get(`${process.env.REACT_APP_API_URL}/stock/export?talk=${hash}`)
        .then(({ data }) => {
          setBase({
            ...base,
            exports: data.exports,
            list: data.exports
          })
          setReload(false)
        })
        .catch(function (error) {
          console.log(error)
          alert("Erreur de communication avec la base !")
        })
      qrcodeRef.current.focus()
    }
  }, [base, hash, reload])


  const handleUpdate = event => {
    if (event.target.name === "qrcode") {
      const str = event.target.value
      const words = str.split(";")
      if (words[10] !== undefined && words[10] === "V1") {
        setInfoOutStock({
          ...infoOutStock,
          idcarton: words[0],
        })
        if (parseInt(words[0]) > 0 && parseInt(words[5]) !== 0) {
          checkStock(parseInt(words[0]), parseInt(words[5]))
        }
      }
    } else {
      setInfoOutStock({ ...infoOutStock, [event.target.name]: event.target.value })
    }
  }

  const checkStock = (idcartonArg = null) => {
    let theIdcarton = idcartonArg === null ? infoOutStock.idcarton : idcartonArg

    if (parseInt(theIdcarton) > 0) {
      setLoading(true)
      axios.post(`${process.env.REACT_APP_API_URL}/stock/checkStock?talk=${hash}`, {
        idcarton: parseInt(theIdcarton),
      })
        .then(function (response) {
          if (response.status === 200) {
            setReload(true)
            qrcodeRef.current.value = ""
            setInfoOutStock({
              ...infoOutStock,
              idcarton: "",
            })
          } else {
            console.log("400");
          }
        })
        .catch(function (error) {
          console.log(error)
        });
      setLoading(false)
    }
  }

  const handleRemove = (car_id) => {
    if (parseInt(car_id) > 0) {
      axios.post(`${process.env.REACT_APP_API_URL}/stock/remove?talk=${hash}`, {
        idcarton: parseInt(car_id),
      })
        .then(function (response) {
          if (response.status === 200) {
            console.log("200");
            setReload(true)
          } else {
            console.log("400");
          }
        })
        .catch(function (error) {
          console.log(error)
        });
    }
  }

  return (
    <>
      <Header />
      <div className="noprint">
        <div className="hero pattern-zigzag-light" style={{ marginTop: -4 }}>
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="title is-2 has-text-centered">Inventaire</h1>
            </div>
          </div>
        </div>
        <div className="container is-fluid pb-5">
          <div className="columns is-centered">
            <div className="column couleurShadow">
              <div className="box">
                <h2 className="is-size-4 mb-4" style={{ color: "#7e421e", paddingBottom: 5, borderBottom: "1px solid #ccc" }}>Scanner le QR Code</h2>
                <form>
                  <div className="columns">
                    <div className="column">
                      <div className="field ">
                        <label className="label" htmlFor="qrcode">
                          &nbsp;
                        </label>
                        <div className="control">
                          <input type="text" required id="qrcode" name="qrcode" ref={qrcodeRef} onChange={e => handleUpdate(e)} className="input" placeholder="Scannez QR Code" autoComplete="off" autoFocus />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="container is-fluid pb-5">
          <div className="columns is-centered">
            <div className="column">
              <div className="box">
                <h2 className="is-size-4 mb-4" style={{ color: "#7e421e", paddingBottom: 5, borderBottom: "1px solid #ccc" }}>Liste <button className={`button is-loading${loading ? ' ' : ' is-hidden'}`}></button></h2>
                <Loader
                  type="Rings"
                  color="#3e8ed0"
                  height={100}
                  width={100}
                  className={`center-div ${base.exports.length === 0 ? `` : `is-hidden`} `}
                />
                <table className={`table is-striped is-fullwidth ${base.exports.length === 0 ? `is-hidden` : ``} `}>
                  <thead>
                    <tr>
                      <th>Fournisseur</th>
                      <th>Réf. fournisseur</th>
                      <th className="has-text-centered">Casier</th>
                      <th className="has-text-centered">Date entrée</th>
                      <th className="has-text-centered">Date inventaire</th>
                      <th className="has-text-centered">Numéro Carton</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {base.list.sort((a, b) => parseInt(b.car_id) - parseInt(a.car_id)).map(ca => (
                      <tr key={ca.car_id} style={{ background: !ca.dateReadDiff || ca.dateReadDiff > 31 ? 'transparent' : 'green'}}>
                        <td>{ca.fo_libelle}</td>
                        <td>{ca.ba_ref_fournisseur}</td>
                        <td className="has-text-centered">{ca.ca_libelle}</td>
                        <td className="has-text-centered">{ca.car_timestamp}</td>
                        <td className="has-text-centered">{ca.car_date_read}</td>
                        <td className="has-text-centered">{ca.car_id}</td>
                        <td className="has-text-centered"><button id={`remove-${ca.car_id}`} title="Supprimer définitivement" onClick={() => handleRemove(ca.car_id)} className={`nobutton`} >
                          <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                        </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Inventaire
